module.exports = __webpack_public_path__ + "static/media/leopard_head_orientation_right.591f9f5c.jpeg";